import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { IAbstractView } from '@core/interfaces';
import { ResetPasswordStrategyPresenter } from './reset-password-strategy.presenter';
import { IResetPasswordStrategyComponent, IResetPasswordStrategyPresenter } from './interfaces';
import { AuthModalComponentEnum } from '../../../enums';
import { InputComponent, ButtonComponent, IconComponent } from '@shared/components';

@Component({
	selector: 'app-reset-password-strategy',
	templateUrl: './reset-password-strategy.component.html',
	styleUrls: ['./reset-password-strategy.component.scss'],
	standalone: true,
	imports: [CommonModule, FormsModule, IonicModule, InputComponent, ButtonComponent, IconComponent],
})
export class ResetPasswordStrategyComponent
	extends IAbstractView<IResetPasswordStrategyPresenter>
	implements IResetPasswordStrategyComponent
{
	token = this.presenter.token;
	newPassword = this.presenter.newPassword;
	confirmNewPassword = this.presenter.confirmNewPassword;
	loading = this.presenter.loading;
	errorMessage = this.presenter.errorMessage;
	successMessage = this.presenter.successMessage;
	passwordChanged = this.presenter.passwordChanged;
	invalidToken = this.presenter.invalidToken;
	passwordRequirements = this.presenter.passwordRequirements;
	passwordsMatch = this.presenter.passwordsMatch;
	translations = this.presenter.translations;

	@Input({ required: true }) callback = this.presenter.callback;
	@Input() visitingCheckout = this.presenter.visitingCheckout;

	constructor(presenter: ResetPasswordStrategyPresenter) {
		super(presenter);
	}

	checkPasswordRequirements(password: string): void {
		this.presenter.checkPasswordRequirements(password);
	}

	checkPasswordsMatch(): void {
		this.presenter.checkPasswordsMatch();
	}

	isPasswordValid(): boolean {
		return this.presenter.isPasswordValid();
	}

	onPasswordChange(): void {
		this.presenter.onPasswordChange();
	}

	onConfirmPasswordChange(): void {
		this.presenter.onConfirmPasswordChange();
	}

	onResetPassword(): void {
		this.presenter.onResetPassword();
	}

	navigateToSignIn(): void {
		this.presenter.navigateToSignIn();
	}

	navigateTo(route: AuthModalComponentEnum): void {
		this.presenter.navigateTo(route);
	}

	getButtonType(isDisabled: boolean | null): 'button-primary' {
		return (isDisabled ? 'button-primary disabled' : 'button-primary') as unknown as 'button-primary';
	}
}
